import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RichTextEditor from './Forms/RichTextEditor';
import { ActionButton } from './Forms/ActionButton';
import { useCreateTnc, useGetAppTnc, useUpdateTnc } from '../queries/appInfo';
import { FaAngleDown, FaAngleRight } from 'react-icons/fa';

const Tnc = () => {

    const { data: tnc, isPending: isTncPending } = useGetAppTnc();
    const { mutateAsync: updateTnc, isPending: isUpdating } = useUpdateTnc();
    const { mutateAsync: createTnc } = useCreateTnc();

    const [show, setShow] = React.useState(false);

    const {
        handleSubmit,
        formState: { errors },
        setValue,
        watch
    } = useForm({
        defaultValues: {
            termsAndConditions: '',
        }
    });

    // Watch form values for rich text editors
    const termsAndConditions = watch('termsAndConditions');

    // Set form values when data is loaded
    useEffect(() => {
        if (tnc) {
            setValue('termsAndConditions', tnc.content || '');
        }
    }, [tnc, setValue]);

    const handleUpdateAppInfo = async (formData) => {
        try {
            if (tnc?._id) {
                await updateTnc(
                    {
                        id: tnc?._id,
                        content: termsAndConditions,
                    },
                    {
                        onSuccess: (res) => {
                            if (res.error) {
                                toast.error();
                                return;
                            }
                            toast.success('Terms Updated!');
                        },
                        onError: (err) => {
                            toast.error('Error updating Terms!');
                        }
                    }
                );
            } else {
                await createTnc(
                    { content: termsAndConditions },
                    {
                        onSuccess: (res) => {
                            if (res.error) {
                                toast.error();
                                return;
                            }
                            toast.success('Terms Created!');
                        },
                        onError: (err) => {
                            toast.error('Error creating Terms!');
                        }
                    }
                );
            }
        } catch (err) {
            toast.error("Failed to update app information");
        }
    };

    if (isTncPending) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="loader">Loading...</div>
            </div>
        );
    }

    return (
        <>
            <div className='bg-white shadow-md rounded-lg p-7'>
                <form onSubmit={handleSubmit(handleUpdateAppInfo)} className="space-y-6">

                    {/* Terms and Conditions Section */}
                    <div className="bg-gray-50 rounded-lg">
                        <h3 className="text-xl text-primary font-bold mb-4 cursor-pointer flex items-center" onClick={() => setShow(!show)}>{show ? <FaAngleDown className='text-secondary' /> : <FaAngleRight className='text-secondary' />} Terms and Conditions</h3>
                        {
                            show && (
                                <>
                                    <RichTextEditor
                                        label="Terms and Conditions Content"
                                        value={termsAndConditions}
                                        placeholder="Enter the terms and conditions for your app..."
                                        onChange={(value) => setValue('termsAndConditions', value)}
                                        required={true}
                                    />
                                    {errors.termsAndConditions && (
                                        <p className="text-red text-sm mt-2">
                                            {errors.termsAndConditions.message || "Terms and Conditions are required"}
                                        </p>
                                    )}
                                    {/* Submit Button */}
                                    <div className='flex justify-end mt-6'>
                                        <ActionButton
                                            text={isUpdating ? 'Updating...' : 'Update Terms'}
                                            variant={'submit'}
                                            disabled={isUpdating}
                                        />
                                    </div>
                                </>
                            )
                        }
                    </div>
                </form>
            </div>

            <ToastContainer
                position="top-right"
                autoHideDuration={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

export default Tnc;